export default __webpack_public_path__ + "static/media/like_icon.6ed66e25.png";